import { render, staticRenderFns } from "./BookingHead.vue?vue&type=template&id=c404a4d0&"
import script from "./BookingHead.vue?vue&type=script&lang=js&"
export * from "./BookingHead.vue?vue&type=script&lang=js&"
import style0 from "./BookingHead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports